module.exports = __webpack_public_path__ + "media/images/siq-shield-results-8c1b3ffb7dd746116ebfc365ce7e3147.png";